import overlordPreview from 'assets/images/ForInfluencersPage/Roles/overlord.png';
import overlord from 'assets/images/ForInfluencersPage/Roles/overlord_big.jpg';
import memeticanPreview from 'assets/images/ForInfluencersPage/Roles/memetican.png';
import memetican from 'assets/images/ForInfluencersPage/Roles/memetican_big.jpg';
import industrialistPreview from 'assets/images/ForInfluencersPage/Roles/industrialist.png';
import industrialist from 'assets/images/ForInfluencersPage/Roles/industrialist_big.jpg';
import underdogPreview from 'assets/images/ForInfluencersPage/Roles/underdog.png';
import underdog from 'assets/images/ForInfluencersPage/Roles/underdog_big.jpg';

export const RoleCards = [
    {
        title: 'OVERLORD (Apex Predator)',
        description: 'You are the god of war. Your goal is legendary loot, exclusive titles, and server-wide terror. You are the "whale" funding the entire fucking war.',
        hint: 'For: top PVP streamers, guild leaders.',
        image: overlord,
        image_preview: overlordPreview,
    },
    {
        title: 'MEMETICIAN (The Soul & Memory Of Miut)',
        description: 'You create memes, write guides, help newbies, organize events. You create the content that keeps people hooked.',
        hint: 'For: guide creators, meme lords, roleplayers.',
        image: memetican,
        image_preview: memeticanPreview,
    },
    {
        title: 'INDUSTRIALIST (Engine Of War & Economy)',
        description: 'You are an ambitious fighter or a business tycoon. You don\'t just fight – you profit from the war. Compete in tournaments, build factories, control markets.',
        hint: 'For: hardcore PVP players, economy streamers.',
        image: industrialist,
        image_preview: industrialistPreview,
    },
    {
        title: 'UNDERDOG (Cannon Fodder With Ambition)',
        description: 'You are the cannon fodder dreaming of becoming steel. The perfect mercenary. You are the one Patricians and Knights build their status upon.',
        hint: 'For: players with more time and skill than money.',
        image: underdog,
        image_preview: underdogPreview,
    },
];